import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '@shared/components/ui/loader/loader.service';
import { SKIP_LOADER_HEADER } from '@constants';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  if (req.url.includes('/i18n/') || req.url.includes('/assets/i18n/')) {
    return next(req);
  }

  if (req.headers.has(SKIP_LOADER_HEADER)) {
    return next(req.clone({ headers: req.headers.delete(SKIP_LOADER_HEADER) }));
  }

  loaderService.show();

  return next(req).pipe(
    finalize(() => loaderService.hide())
  );
};
